const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "VESSELS_UPDATED":
            return action.vessels;

        default:
            return state;
    }
}

